<template>
  <v-container fluid class="pa-0 mx-0">
    <div style="overflow-x: scroll">
      <v-data-table
        mobile-breakpoint="0"
        :headers="headers"
        :items="filteredStocks"
        :items-per-page="15"
        :options.sync="options"
        class="elevation-0"
      >
        <template v-slot:header>
          <tr>
            <th v-for="(header, idx) in headers" :key="`header-${idx}`">
              <v-text-field
                dense
                class="ma-2"
                rounded
                v-model="filter[header.value]"
                placeholder="filter"
                solo-inverted
                hide-details
                flat
              ></v-text-field>
            </th>
          </tr>
        </template>
        <template v-slot:[`item.pictureId`]="{ item }">
          <v-container>
            <img
              class="image-preview"
              :src="getProductPictureUrlById(item.pictureId)"
            />
          </v-container>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.vendorId`]="{ item }">
          {{ getVendorName(item.vendorId) }}
        </template>
        <template v-slot:[`item.stockPrice`]="{ item }">
          <span class="mr-1">$</span
          ><span>{{ convertToCleanNumber(item.stockPrice) }}</span>
        </template>
        <template v-slot:[`item.expDate`]="{ item }">
          {{ convertToUsDate(item.expDate) }}
        </template>
        <template v-slot:[`item.datePurchased`]="{ item }">
          {{ convertToUsDate(item.datePurchased) }}
        </template>
        <template v-slot:[`item.dateCreated`]="{ item }">
          {{ convertToUsDate(item.dateCreated) }}
        </template>
        <template v-slot:[`item.createdBy`]="{ item }">
          <span class="mr-1">{{ getUserName(item.createdBy) }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            color="warning"
            icon
            depressed
            @click="
              () => {
                selectedProduct = {
                  id: item.productId,
                  pictureId: item.pictureId,
                };
                inStockDialog = true;
                selectedStock = JSON.parse(JSON.stringify(item));
              }
            "
            :disabled="!item.isActive"
            ><i class="fa-solid fa-gear"></i
          ></v-btn>
        </template>
      </v-data-table>
    </div>
    <in-stock-dialog
      v-if="inStockDialog"
      :p-product="selectedProduct"
      :p-stock="selectedStock"
      :is-updating="true"
      v-model="inStockDialog"
      @update="$emit('update', selectedStock)"
      @delete="$emit('delete', selectedStock)"
    ></in-stock-dialog>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service.js";
import generalMixin from "@/js/general-mixin";
import eventBus from "@/js/event-bus";
import InStockDialog from "@/components/InStockDialog.vue";
export default {
  name: "StockList",
  mixins: [generalMixin],
  components: { "in-stock-dialog": InStockDialog },
  mounted: function () {
    eventBus.$on("generateCsv", this.generateCsv);
  },
  props: {
    stocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      inStockDialog: false,
      selectedProduct: null,
      selectedStock: null,
      headers: [
        {
          text: "Id",
          align: "end",
          value: "id",
          width: "80",
        },
        { text: "Picture", value: "pictureId", width: "100" },
        { text: "Product", value: "productName", width: "400" },
        { text: "Vendor", value: "vendorId", align: "end", width: "200" },
        { text: "Quantity", value: "quantity", align: "end", width: "100" },
        {
          text: "Stock Price",
          value: "stockPrice",
          align: "end",
          width: "100",
        },
        { text: "Exp Date", value: "expDate", align: "end", width: "150" },
        {
          text: "Date Purchased",
          value: "datePurchased",
          align: "end",
          width: "150",
        },
        {
          text: "Date Created",
          value: "dateCreated",
          align: "end",
          width: "150",
        },
        {
          text: "Created By",
          value: "createdBy",
          width: "200",
        },
        {
          text: "Action",
          value: "action",
          width: 50,
        },
      ],
    };
  },
  computed: {
    customers() {
      return this.$store.getters["customers"];
    },
    filteredStocks() {
      let stocks = this.stocks;
      for (let key in this.filter) {
        let searchStr = this.filter[key].trim().toLowerCase();
        let header = this.headers.find((header) => header.value == key);
        if (searchStr && searchStr.length) {
          stocks = stocks.filter((e) => {
            let str = this.getDataText(header, e);
            return str
              .toString()
              .trim()
              .toLowerCase()
              .includes(this.filter[key].toLowerCase());
          });
        }
      }
      return stocks;
    },
    options: {
      get() {
        return this.$store.getters["interactStore/stockOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setStockOptions", val);
      },
    },
    filter: {
      get() {
        return this.$store.getters["interactStore/stockFilter"];
      },
      set(val) {
        this.$store.commit("interactStore/setStockFilter", val);
      },
    },
  },
  methods: {
    generateCsv() {
      let headerStr =
        "Id;Product;Supplier;Quantity;Stock Price;Exp Date;Date Purchased;Date Created;Created By";
      let csvContent = "";
      csvContent += headerStr + "\r\n";
      for (let i = 0; i < this.filteredStocks.length; i++) {
        const stock = this.filteredStocks[i];
        let rowStr = `${stock.id};${stock.productName};${this.getOptionName(
          stock.supplierId
        )};${stock.quantity};${this.convertToCleanNumber(
          stock.stockPrice
        )};${this.convertToUsDate(stock.expDate)};${this.convertToUsDate(
          stock.datePurchased
        )};${this.convertToDate(stock.dateCreated)};${stock.createdBy.first} ${
          stock.createdBy.last
        }`;

        csvContent += rowStr + "\r\n";
      }
      let blob = new Blob([csvContent], { type: "text/plain" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `stock-list.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDataText(header, stock) {
      if (header.value == "id") {
        return stock.id.toString();
      } else if (header.value == "vendorId") {
        return this.getVendorName(stock.vendorId);
      } else if (header.value == "productName") {
        return stock.productName;
      } else if (header.value == "quantity") {
        return stock.quantity.toString();
      } else if (header.value == "stockPrice") {
        return stock.stockPrice.toString();
      } else if (header.value == "datePurchased") {
        return this.convertToUsDate(stock.datePurchased);
      } else if (header.value == "expDate") {
        return this.convertToUsDate(stock.expDate);
      } else if (header.value == "dateCreated") {
        return this.convertToDate(stock.dateCreated);
      } else if (header.value == "createdBy") {
        return `${stock.createdBy.first} ${stock.createdBy.last}`;
      } else {
        return "";
      }
    },
    getProductPictureUrlById(id) {
      return backendService.getProductPictureUrlById(id);
    },
  },
  destroyed: function () {
    eventBus.$off("generateCsv");
  },
};
</script>
<style>
.payment-paid {
  background-color: lightgreen;
}
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 40px;
  height: 40px;
}
</style>
